import { ThemeOptions } from '@material-ui/core';
import { grey/* , common */ } from '@material-ui/core/colors';

const logoPrimary = '#ed6827';
// const logoSecondary = '#1b1918';
// const logoLight = common.white;

export const defaultTheme: ThemeOptions = {
  palette: {
    primary: {
      main: logoPrimary,
    },
    secondary: {
      main: grey[900],
    },
    background: {
      default: grey[100],
      paper: grey[50],
    },
    text: {
      primary: '#1b1918',
      secondary: '#ed6827',
    },
    common: {
      black: '#1b1918',
    },
  },
  typography: {
    fontFamily: '"Montserrat", "Helvetica", "Arial", "sans-serif"',
    fontWeightBold: 'bold',
  },
};

export default defaultTheme;
